import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// O2: Inicializar Sentry antes de renderizar a aplicação
// SENTRY_DSN é injetado em tempo de build via variável de ambiente REACT_APP_SENTRY_DSN
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    // Capturar 10% das transações em produção para performance monitoring
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
    // Não capturar erros de desenvolvimento local
    enabled: process.env.NODE_ENV !== 'development',
    integrations: [Sentry.browserTracingIntegration()],
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
